var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-ins-progress-bar'),(_vm.notAllowed)?_c('div',[_c('LocationNotAllowed')],1):_c('div',[_c(_vm.layout,{tag:"component"},[_c('RouterView')],1)],1),_vm._m(0),_c('div',{attrs:{"id":"swal-output"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolltop text-center",attrs:{"id":"scroll-to-top"}},[_c('i',{staticClass:"fas fa-chevron-up",staticStyle:{"font-size":"20px"}})])
}]

export { render, staticRenderFns }